/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'GoalLinker.error.generic.description': 'Please check your internet connection and try again.',
  'GoalLinker.error.generic.header': 'Something went wrong',
  'GoalLinker.error.linking.header': 'Could not link goal',
  'GoalLinker.error.max-entities-to-goal.description':
    'A maximum of 100 {entities} can be linked to a goal. Please remove a {entity} if you wish to link additional {entities}.',
  'GoalLinker.error.max-entities-to-goal.header': '100 {entity} limit reached',
  'GoalLinker.error.max-goals.description':
    'A maximum of 100 goals can be linked. Please remove linked goals if you wish to link additional goals.',
  'GoalLinker.error.max-goals.header': '100 goal limit reached',
  'GoalLinker.goal-row.open-goal': 'Open goal',
  'GoalLinker.link-goals.error-description':
    'Something went wrong, please check your internet connection and try again.',
  'GoalLinker.link-goals.error-title': 'Could not unlink goal',
  'GoalLinker.linked-goals.header': 'Linked goals',
  'GoalLinker.linked-goals.show-less': 'Show less',
  'GoalLinker.linked-goals.show-more': 'Show {count} more',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'Link ideas to goals to track how work contributes to outcomes',
  'GoalLinker.recents.emptystate-project.description':
    'Link your project to goals to track how work ladders to outcomes',
  'GoalLinker.recents.emptystate.description': 'Link your work items to goals to track how work ladders to outcomes',
  'GoalLinker.recents.emptystate.header': 'Get started with goals',
  'GoalLinker.recents.header': 'Recent goals',
  'GoalLinker.search.emptystate.description': 'Try checking for typos',
  'GoalLinker.search.emptystate.header': 'No matching results',
  'GoalLinker.search.label': 'Results',
  'GoalLinker.search.placeholder': 'Search for goals or paste link',
};
